import { StargraveLootType, StargraveMemberGameState, StargraveStat, StargraveStatLine } from '../types';
import { StatModifier } from '../utils/splitStats';

export function isStargraveWounded(
  gameState: StargraveMemberGameState,
  maximumHealth: number,
  isRobot: boolean
): boolean {
  return !isRobot && gameState.currentHealth < maximumHealth && gameState.currentHealth <= 4;
}

export function applyStargraveDamage(
  gameState: StargraveMemberGameState,
  amount: number
): StargraveMemberGameState {
  const damage = Math.max(0, Math.floor(amount));
  return {
    ...gameState,
    currentHealth: Math.max(0, gameState.currentHealth - damage),
    stunned: gameState.stunned || damage >= 4,
  };
}

export function applyStargraveHealing(
  gameState: StargraveMemberGameState,
  amount: number,
  maximumHealth: number
): StargraveMemberGameState {
  const healing = Math.max(0, Math.floor(amount));
  return {
    ...gameState,
    currentHealth: Math.min(maximumHealth, gameState.currentHealth + healing),
  };
}

/** Physical loot: half Move (rounded up), -1 Fight, -1 Shoot. Data loot carries no penalty. */
export function getStargraveLootPenalties(
  stats: StargraveStatLine,
  loot: StargraveLootType | null
): Partial<StargraveStatLine> {
  if (loot !== 'physical') return {};
  return {
    move: Math.ceil(stats.move / 2) - stats.move,
    fight: -1,
    shoot: -1,
  };
}

export function applyStargraveLootPenalties(
  stats: StargraveStatLine,
  loot: StargraveLootType | null
): StargraveStatLine {
  const penalties = getStargraveLootPenalties(stats, loot);
  return {
    ...stats,
    move: stats.move + (penalties.move ?? 0),
    fight: stats.fight + (penalties.fight ?? 0),
    shoot: stats.shoot + (penalties.shoot ?? 0),
  };
}

export function getStargraveLootStatModifiers(
  stats: StargraveStatLine,
  loot: StargraveLootType | null,
  stat: StargraveStat
): StatModifier[] {
  const value = getStargraveLootPenalties(stats, loot)[stat];
  return value === undefined || value === 0 ? [] : [{ label: 'Physical loot', value, type: 'add' }];
}

